// src/utils/utils.js
export const slugify = (text) => {
  let processedText = text;

  // بررسی می‌کنیم که آیا "(ناموجود)" در متن وجود دارد یا خیر
  const hasNamojood = text.includes("(ناموجود)");

  if (hasNamojood) {
    // اگر "(ناموجود)" وجود داشت، فقط پرانتزهای دیگر را حذف می‌کنیم.
    // اما "(ناموجود)" را نگه می‌داریم.
    processedText = text.replace(/\((?!ناموجود).*?\)/g, ""); // حذف هر پرانتزی به جز "(ناموجود)"
  } else {
    // اگر "(ناموجود)" وجود نداشت، تمام پرانتزها را حذف می‌کنیم.
    processedText = text.replace(/\(.*?\)/g, "");
  }

  // حالا مراحل استاندارد slugify را روی متن پردازش شده اعمال می‌کنیم
  const slug = processedText
    .toString()
    .trim() // حذف فاصله‌های اضافی اول و آخر
    .replace(/\s+/g, "-") // جایگزینی یک یا چند فاصله با یک خط تیره
    // فقط حروف فارسی (\u0621-\u06FF)، اعداد فارسی (\u06F0-\u06F9)،
    // اعداد لاتین (0-9)، (اگر ناموجود بود: پرانتزها)، فاصله‌ها و خط تیره (-) را نگه می‌دارد
    .replace(/[^\u0621-\u06FF\u06F0-\u06F90-9()\s-]/g, "") // نگه داشتن پرانتزها فقط اگر در processedText وجود داشتند
    .replace(/--+/g, "-"); // جایگزینی چند خط تیره متوالی با یک خط تیره

  return slug;
};
